import dateFnsFormat from 'date-fns/format';

import { DateFormat, formatDateWithYear } from '@lyearn/core/utils/date/formatDate';

export const formatDimensionHTML = (value: string) => {
  const parser = new DOMParser();
  return parser.parseFromString(value, 'text/html').body.textContent ?? '';
};

export const formatDimensionDate = (value: string) => {
  const dateTokens = value.split('-');
  if (dateTokens.length !== 3) {
    return value;
  }

  // 2023-11-30
  const year = Number(dateTokens[0]);
  const month = Number(dateTokens[1]) - 1;
  const date = Number(dateTokens[2]);

  const dateObject = new Date(year, month, date);
  return formatDateWithYear(dateObject, DateFormat.Date);
};

export const formatDimensionMonth = (value: string) => {
  const dateTokens = value.split('-');
  if (dateTokens.length !== 2) {
    return value;
  }

  // 2023-11
  const year = Number(dateTokens[0]);
  const month = Number(dateTokens[1]) - 1;

  const dateObject = new Date(year, month);
  return dateFnsFormat(dateObject, 'MMM yyyy');
};

const DIMENSION_FORMATTERS = {
  html: formatDimensionHTML,
  date: formatDimensionDate,
  month: formatDimensionMonth,
  default: (value: string) => value,
};

export const getFormattedDimension = (format: string | undefined, value: string) => {
  const formatter = DIMENSION_FORMATTERS[format as keyof typeof DIMENSION_FORMATTERS];
  return formatter ? formatter(value) : DIMENSION_FORMATTERS.default(value);
};
